// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38vNw","textarea":"styles_textarea__2Ry1I"};